export default __webpack_public_path__ + "static/media/sacred.a3e45cd6.png";